import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { t } from '../../i18n/translate.js';
import Input from '../Input/Input.js';
import Flag from '../Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import { PHONE_MAX_LENGTH, PHONE_MIN_LENGTH } from '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import { countries, preferredCountries } from '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import { useTrackPopOver } from '../../services/useTrackPopOver/useTrackPopOver.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import Icon from '../Icon/Icon.js';
import PhoneSelectButton from '../PhoneSelectButton/PhoneSelectButton.js';
import PopOver from '../PopOver/PopOver.js';
import styles from './InternationalPhonePicker.module.scss.js';

var InternationalPhonePicker = function (_a) {
    var phoneNumber = _a.phoneNumber, setPhoneNumber = _a.setPhoneNumber, phoneError = _a.phoneError, selectedCountryPhone = _a.selectedCountryPhone, setSelectedCountryPhone = _a.setSelectedCountryPhone, disabled = _a.disabled, errorMessage = _a.errorMessage, popOverMessage = _a.popOverMessage, popOverDescription = _a.popOverDescription, supportedDialCodes = _a.supportedDialCodes, placeholderText = _a.placeholderText;
    var _b = useState(false), menuExpanded = _b[0], setMenuExpanded = _b[1];
    var PHONE_MAX_LENGTH$1 = PHONE_MAX_LENGTH, PHONE_MIN_LENGTH$1 = PHONE_MIN_LENGTH;
    var showPopOver = popOverMessage && popOverDescription;
    var _c = useTrackPopOver(), infoTextVisible = _c.infoTextVisible, onClickInfo = _c.onClickInfo;
    var sortedCountries = (supportedDialCodes === null || supportedDialCodes === void 0 ? void 0 : supportedDialCodes.length)
        ? countries
            .filter(function (country) { return supportedDialCodes.map(function (dialCode) { return dialCode.replace('00', '+'); }).includes(country.dialCode); })
            .sort(function (a, b) {
            if (a.preferred && !b.preferred)
                return -1;
            if (!a.preferred && b.preferred)
                return 1;
            return 0;
        })
        : preferredCountries;
    var examplePhoneNumber = function () {
        var _a;
        if ((phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) !== 0) {
            return '';
        }
        return (_a = selectedCountryPhone === null || selectedCountryPhone === void 0 ? void 0 : selectedCountryPhone.example) !== null && _a !== void 0 ? _a : '';
    };
    var handleCountryChange = function (country) {
        setSelectedCountryPhone(country);
        setMenuExpanded(false);
    };
    var buttonRefs = useRef({});
    useEffect(function () {
        if (selectedCountryPhone) {
            var selectedButton = buttonRefs.current["".concat(selectedCountryPhone.dialCode, "-").concat(selectedCountryPhone.code)];
            if (selectedButton) {
                selectedButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, [selectedCountryPhone, menuExpanded]);
    var maxNumberLength = (selectedCountryPhone === null || selectedCountryPhone === void 0 ? void 0 : selectedCountryPhone.dialCode) && !disabled
        ? PHONE_MAX_LENGTH$1 - (selectedCountryPhone.dialCode.replace('+', '').length + 2)
        : PHONE_MAX_LENGTH$1;
    if (phoneNumber && phoneNumber.length > maxNumberLength) {
        setPhoneNumber(phoneNumber.slice(0, maxNumberLength));
    }
    var hasInsertedSeparator = false;
    return (React.createElement("div", { className: styles.contentWrapper },
        showPopOver && (React.createElement("div", { className: styles.infoText },
            React.createElement("div", { className: styles.text }, t(popOverMessage)),
            React.createElement("div", { className: styles.popoverContainer },
                React.createElement(Icon, { icon: "icon-help-contextual", size: "small", className: styles.icon, onClick: onClickInfo, tabIndex: -1, dataTestId: "phonenumber-not-editable-icon" }),
                infoTextVisible && (React.createElement(PopOver, { visible: infoTextVisible, className: classNames(styles.popover, infoTextVisible && styles.popoverVisible) },
                    React.createElement("p", { className: styles.infoText, id: "phonenumber-not-editable-text" }, t(popOverDescription))))))),
        React.createElement("div", { className: styles.inputWrapper },
            React.createElement("div", { className: styles.inputFields },
                !disabled && (React.createElement(PhoneSelectButton, { country: selectedCountryPhone, menuController: { menuExpanded: menuExpanded, setMenuExpanded: setMenuExpanded }, hasError: phoneError }, sortedCountries.map(function (country) {
                    var isNonPreferred = !country.preferred;
                    var shouldInsertSeparator = isNonPreferred && !hasInsertedSeparator;
                    if (shouldInsertSeparator) {
                        hasInsertedSeparator = true;
                    }
                    return (React.createElement(React.Fragment, { key: "".concat(country.code, "-").concat(country.dialCode) },
                        shouldInsertSeparator && React.createElement("div", { className: styles.separator }),
                        React.createElement("button", { 
                            // eslint-disable-next-line no-return-assign
                            ref: function (el) { return (buttonRefs.current["".concat(country.dialCode, "-").concat(country.code)] = el); }, onClick: function () { return handleCountryChange(country); }, value: country.dialCode, type: "button", tabIndex: -1 },
                            React.createElement("div", { className: styles.countryContainer },
                                React.createElement("div", { className: classNames(country.code === (selectedCountryPhone === null || selectedCountryPhone === void 0 ? void 0 : selectedCountryPhone.code) &&
                                        country.dialCode === (selectedCountryPhone === null || selectedCountryPhone === void 0 ? void 0 : selectedCountryPhone.dialCode) &&
                                        styles.countrySelected) },
                                    React.createElement(Flag, { country: country.code, lazyLoadImgWhenScolling: true }),
                                    React.createElement("span", null,
                                        country.name,
                                        " ",
                                        country.dialCode)),
                                React.createElement("div", { className: styles.countrySelected }, country.code === (selectedCountryPhone === null || selectedCountryPhone === void 0 ? void 0 : selectedCountryPhone.code) &&
                                    country.dialCode === (selectedCountryPhone === null || selectedCountryPhone === void 0 ? void 0 : selectedCountryPhone.dialCode) &&
                                    '✓')))));
                }))),
                React.createElement("div", { className: styles.inputField },
                    React.createElement(Input, { placeholder: examplePhoneNumber(), value: phoneNumber, dataTestId: "PhoneNumberInput", maxLength: maxNumberLength, minLength: PHONE_MIN_LENGTH$1, type: "tel", inputMode: "tel", onChange: function (value) { return setPhoneNumber(value.replace(/\D/g, '')); }, hasError: phoneError, className: styles.phoneInput, disabled: disabled })),
                React.createElement("label", { className: styles.phoneNumberLabel }, placeholderText || t('MPLIB_MOBILE_PHONE_PLACEHOLDER'))),
            phoneError && (React.createElement("div", { id: "PhoneNumberInputErrorMessage", className: styles.errorLabel }, errorMessage)))));
};

export { InternationalPhonePicker as default };
